import React from "react";
import "./PrivacyPolicy.css";
import Footer from "../components/Footer";
import PageWrapper from "../components/PageWrapper";

export default function PrivacyPolicy() {
  return (
    <PageWrapper>
      <div
        className="privacy-container"
        style={{
          padding: "80px 30px 30px 30px",
          maxWidth: "900px",
          margin: "auto",
          whiteSpace: "pre-wrap",
        }}
      >
        <h1>Privacy Policy</h1>

        <h2>About Us</h2>
        <p>
          MindBlows (“MindBlows”) develops and publishes apps for mobile
          devices (each app, “Title”). We collect information in either
          of 2 ways:
        </p>
        <ul>
          <li>
            <strong>Directly</strong> – from your device through the Titles via
            analytics partners.
          </li>
          <li>
            <strong>Indirectly</strong> – through advertising and analytics
            partners as a data controller.
          </li>
        </ul>

        <h2>Scope</h2>
        <p>
          This privacy policy describes MindBlows' practices for Titles only. It
          doesn’t govern our website or other services. Our titles are available
          globally, with sections addressing GDPR and CCPA where relevant.
        </p>

        <h2>Information We Collect</h2>

        <h3>Information collected directly from you or via ad networks</h3>
        <ul>
          <li>
            <strong>Identifiers:</strong> Advertising ID, IP address, browser
            settings. These include the Google Advertising ID on Android and
            IDFA/IDFV on iOS. They help with frequency capping, attribution,
            fraud detection, and personalized ads.
          </li>
          <li>
            <strong>Technical Info:</strong> Time zone, memory, title version,
            battery (Android), OS version, manufacturer, language, carrier,
            internet type, timestamp.
          </li>
          <li>
            <strong>App Activity:</strong> Transactions, in-app purchases,
            usage progress, and events.
          </li>
        </ul>

        <h3>Information from analytics/advertising partners</h3>
        <ul>
          <li>Total ad revenue attributed to a specific device ID.</li>
        </ul>

        <h2>How We Use the Information</h2>
        <ul>
          <li>To operate, optimize, and improve Titles</li>
          <li>For user support, updates, and in-app rewards</li>
          <li>Fraud prevention and legal compliance</li>
          <li>Marketing, monetization, and analytics</li>
        </ul>

        <h2>The GDPR Angle</h2>
        <p>
          For users in the EU/UK/Switzerland, we may collect and use personal
          data under the lawful bases of contract, legitimate interest, or
          consent. You may request access, correction, deletion, restriction, or
          data portability.
        </p>

        <h2>The CCPA Angle</h2>
        <p>
          California residents may access, delete, or opt out of personal info
          sharing. Requests can be sent to{" "}
          <a href="mailto:hello@mindblows.com">hello@mindblows.com</a>.
        </p>

        <h2>Data Retention</h2>
        <p>
          We retain data as long as necessary for the purposes above, including
          legal and business obligations.
        </p>

        <h2>How We Share Information</h2>
        <ul>
          <li>With ad and analytics partners</li>
          <li>Corporate affiliates</li>
          <li>Advertisers and service providers</li>
          <li>Authorities if legally required</li>
        </ul>

        <h2>How to Control Your Information</h2>
        <ul>
          <li>
            <strong>iOS:</strong> Settings → Privacy → Tracking → Disable
            tracking
          </li>
          <li>
            <strong>Android:</strong>{" "}
            <a
              href="https://support.google.com/ads/answer/2662922?hl=en"
              target="_blank"
              rel="noreferrer"
            >
              Disable ad personalization
            </a>
          </li>
        </ul>
        <p>
          You may also reset your advertising ID or use OS-level privacy
          controls.
        </p>

        <h2>Your Rights Under GDPR</h2>
        <p>
          You may request access or deletion of your personal data at{" "}
          <a href="mailto:hello@mindblows.com">hello@mindblows.com</a>.
          Complaints can also be submitted to your local data authority.
        </p>

        <h2>Your Rights Under CCPA</h2>
        <ul>
          <li>Know what personal info is collected/shared</li>
          <li>Request deletion of data</li>
          <li>Opt out of personal info sales</li>
          <li>Exercise rights without discrimination</li>
        </ul>

        <h2>Children</h2>
        <p>
          We do not knowingly collect info from users under 13. If such data is
          found, please contact us to remove it.
        </p>

        <h3>Minors under GDPR</h3>
        <p>
          We do not process personal data of users under 16 unless allowed by
          law.
        </p>

        <h2>International Transfers</h2>
        <p>
          Data may be stored or processed in the U.S. or Europe. We use Privacy
          Shield or model contracts for EU/UK transfers.
        </p>

        <h2>Changes</h2>
        <p>
          We may update this policy periodically. Substantial changes will be
          posted on{" "}
          <a
            href="https://www.mindblows.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            this page
          </a>
          .
        </p>

        <h2>Contact</h2>
        <p>
          MindBlows
          <br />
          Emek HaEla 84, Modiin, Israel
          <br />
          <a href="mailto:hello@mindblows.com">hello@mindblows.com</a>
        </p>
      </div>
      <Footer />
    </PageWrapper>
  );
}
